export const TIME_LOCAL_PAGE_TIMER = '3:00';
export const TIME_EXPIRED_PAGE_TIMER = '15:00';